import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/prestador";

/**
 * Classe de gerenciamento de chamadas da API dos módulos
 *
 * @class
 */
export default class EmissorApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe EmissorApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
     * @returns Lista de Prestadores
     */
    list() {
        return this.api<any>(`${controller}/listar-prestadores`, {
            method: "GET",
        });
    }

    /**
     * Verifica se o prestador existe pelo CNPJ.
     * @param cnpj - CNPJ do prestador
     * @returns Boolean indicando se o prestador existe
     */
    checkIfProviderExists(cnpj: string) {
        return this.api<any>(`${controller}/existeprestador/${cnpj}`, {
            method: "GET",
        });
    }

    /**
     * Retorna os dados de um prestador.
     * @param codEmissor - Código do emissor
     * @returns Dados do prestador
     */
    getProviderData(codEmissor: number) {
        return this.api<any>(`${controller}/dados-prestador/${codEmissor}`, {
            method: "GET",
        });
    }

    /**
     * Retorna os dados de um prestador.
     * @returns Dados do prestador
     */
    getCertificadeData(cnpjCpf: string) {
        return this.api<any>(
            `${controller}/listar-certificados?cnpjCpf=${cnpjCpf}`, {
            method: "GET",
        });
    }
    getCertificadeData2() {
        return this.api<any>(`${controller}/listar-certificados2`, {
            method: "GET",
        });
    }

    /**
     * Retorna os lista de versão NFSe.
     * @returns lista de versão NFSe
     */
    getVersaoNfe() {
        return this.api<any>(`${controller}/listar-versaoNfs`, {
            method: "GET",
        });
    }

    /**
     * Cadastra um novo prestador.
     * @param provider - Dados do prestador a ser cadastrado
     * @returns Resultado do cadastro
     */
    createProvider(provider: any) {
        return this.api<any>(`${controller}/cadastrar`, {
            method: "POST",
            body: provider,
        });
    }

    /**
     * Atualiza os dados de um prestador.
     * @param provider - Dados atualizados do prestador
     * @returns Resultado da atualização
     */
    updateProvider(provider: any) {
        return this.api<any>(`${controller}/atualizar`, {
            method: "PUT",
            body: provider,
        });
    }

    /**
     * Salva o logo da nota fiscal.
     * @param logo Logo em base 64.
     */
    salvarLogo(ini_Blob: {
        CodUsuario: number;
        Parametro: string;
        RegistroAplicacao: string;
        Valor: string;
    }) {
        return this.api<any>(`ini/CadastrarIniBlob`, {
            method: "POST",
            body: ini_Blob,
        });
    }

    carregarLogo(parametro: string, registroAplicacao: string) {
        return this.api<any>(`ini/CarregarIniBlob`, {
            method: "GET",
            params: { parametro, registroAplicacao },
        });
    }

    async consultarDadosPrestador(cnpjCpf: string, im: string) {

        const item = cnpjCpf.length === 14 ? `<CNPJ>${cnpjCpf}</CNPJ>` : `<CPF>${cnpjCpf}</CPF>`;

        const xmlDados = `
                <ConsultarDadosCadastraisEnvio xmlns="http://www.sped.fazenda.gov.br/nfse" xmlns:ns2="http://www.w3.org/2000/09/xmldsig#">                
                    <Prestador>
                        ${item}              
                        <IM>${im}</IM>
                    </Prestador>
                </ConsultarDadosCadastraisEnvio>`;

        const resp = await this.enviarConsulta(xmlDados);
        return resp;
    }

    async enviarConsulta(xmlDados: string) {
        const baseUrl = "http://www.sped.fazenda.gov.br";

        const xml = `<?xml version="1.0" encoding="utf-8"?>
                    <soapenv:Envelope
                    xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/"
                    xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
                    xmlns:xsd="http://www.w3.org/2001/XMLSchema"
                    xmlns:nfse="${baseUrl}/nfse.xsd">

                    <soapenv:Header/>

                    <soapenv:Body>
                        <nfse:ConsultarDadosCadastraisRequest>
                        <nfse:cabecalho versao="1.00">
                            <nfse:versaoDados>1.01</nfse:versaoDados>
                        </nfse:cabecalho>

                        <nfse:ConsultarDadosPrestador>
                            ${xmlDados}
                        </nfse:ConsultarDadosPrestador>
                        </nfse:ConsultarDadosCadastraisRequest>
                    </soapenv:Body>
                    </soapenv:Envelope>`.trim();

        const response = await fetch(
            `${baseUrl}/nfse.asmx`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "text/xml; charset=utf-8",
                    "SOAPAction": `${baseUrl}/nfse.xsd/ConsultarDadosCadastrais`
                },
                body: xml
            }
        );

        const text = await response.text();
        return text;
    }
}
